import React, { useEffect } from 'react';
import { useLanguage } from '../../context/language/LanguageContext';
import Navbar from '../../components/common/Navbar/Navbar';
import Footer from '../../components/common/Footer/Footer';
import './AcceptingRules.css';

const AcceptingRules = () => {
    console.log('AcceptingRules component mounted');

    const { language } = useLanguage();

    const content = {
        en: {
            title: "Accepting Novice Monks at Mahãvihãra",
            noviceTitle: "For Novice Monks:",
            noviceContent: "At Mahãvihãra Monastery, we accept novice monks from the age of 9 years who can follow the Sekhiya rules. Sometimes, if it is determined that one cannot yet follow these rules, they are asked to wear lay robes until they are ready to become a novice again.",
            monkTitle: "For Fully Ordained Monks:",
            monkRules: "There are 3 conditions:",
            rules: [
                "Must have memorized one complete Bhikkhu Patimokkha",
                "Must never have cheated in examinations",
                "Must be receptive to mutual advice and correction"
            ],
            explanation1: "Just as a cowherd must know the number and characteristics of their cattle, a monk must necessarily know the number and meaning of the precepts they must follow. This is why the first condition is established.",
            explanation2: "In the decisions of ancient venerable teachers, there are two different opinions on whether cheating in exams constitutes a Parajika offense. Following the commentary statement 'In matters of serious and light offenses, one should stand with the serious interpretation,' we establish the second condition.",
            explanation3: "In this monastery, regardless of seniority or position as student or teacher, all are given the right to advise and correct each other with loving-kindness. The system of mutual guidance is the lifeblood of this monastery. This practice follows the Buddha's words in the Pacittiya Pali (p.171/2) Dubbaca Sikkhapadha. Therefore, we establish the third condition. Those who cannot follow this condition are considered unfit to stay in this monastery.",
            conclusion: "This is how Mahãvihãra accepts new members into the Sangha."
        },
        my: {
            title: "မဟာဝိဟာရ၏ သံဃာသစ်လက်ခံပုံ",
            noviceTitle: "ရှင်သာမဏေများအတွက်",
            noviceContent: "မဟာဝိဟာရကျောင်းတိုက်၌ သံဃာလက်ခံပုံမှာ ရှင်သာမဏေများအတွက် ရှင်ကျင့်ဝတ် သေခိယတို့ကို လိုက်နာနိုင်သော အသက် ၉-နှစ် အရွယ်မှ စ၍ လက်ခံပေး၏။ ရံဖန်ရံခါ ရှင်ကျင့်ဝတ် သေခိယတို့ကို မလိုက်နာနိုင်သေးသူဟု ယူဆလျှင် ဖိုးသူတော်ဝတ်ဖြင့် နေစေပြီးမှ ကိုရင်ပြန်ဝတ်ပေး၏။",
            monkTitle: "ရဟန်းတော်များအတွက်",
            monkRules: "စည်းကမ်း ၃-ချက်ရှိ၏။",
            rules: [
                "ဘိက္ခုပါတိမောက်တစ်စောင် အာဂုံ ရ ရမည်။",
                "စာမေးပွဲ မသမာသောနည်းဖြင့် ဖြေဆိုဖူးခြင်း မရှိရ။",
                "အချင်းချင်း ပြောဆိုဆုံးမခံနိုင်သူ ဖြစ်ရမည်။"
            ],
            explanation1: "နွားကျောင်းသားသည် မိမိကျောင်းသော နွား၏ အရေအတွက်, အရောင်အဆင်း စသည်တို့ကို သိရသကဲ့သို့ ရဟန်းသည်လည်း မိမိကျင့်ရမည့် သိက္ခာပုဒ်အရေအတွက်၊ အနက်အဓိပွါယ်တို့ကို မဖြစ်မနေ သိရန်လိုအပ်လှပေသည်။ ထို့ကြောင့် နံပါတ် (၁) စည်းကမ်းကို သတ်မှတ်ရပါသည်။",
            explanation2: "ရှေးဆရာတော်ကြီးတို့၏ ဝိနိစ္ဆယများ၌ စာမေးပွဲခိုးဖြေလျှင် ပါရာဇိကကျ/မကျ ဟု ၂-ဝါဒ ကွဲလျက်ရှိပါသည်။ <strong>ဂရုကလဟုကေသု ဂရုကေ ဌာတဗ္ဗံ။</strong> ဟူသော အဋ္ဌကထာစကားကို အလေးအနက်ထားသောအားဖြင့် နံပါတ် (၂) စည်းကမ်းကို သတ်မှတ်ရပါသည်။",
            explanation3: "ဤကျောင်းတိုက်၌ ကြီးသည်ငယ်သည် မရွေး၊ စာသင်သား,စာချဘုန်းကြီး မခွဲခြား အချင်းချင်း အပြန်အလှန် မေတ္တာစေတနာဖြင့် ပြောဆိုဆုံးမခွင့် ပေးထားလေသည်၊။ အချင်းချင်း အပြန်အလှန် ထိန်းကျောင်းသော စနစ်သည် ဤကျောင်းတိုက်၏ အသက်သဖွယ် ဖြစ်၏။ <strong>ဧဝံ သံဝဒ္ဓါ ဟိ တဿ ဘဂဝတော ပရိသာ ယဒိဒံ အညမညဝစနေန အညမညဝုဋ္ဌာပနေနာတိ</strong> ဟူသော ပါစိတ်ပါဠိတော် (နှာ ၁၇၁/၂) ဒုဗ္ဗစသိက္ခာပုဒ်လာ ဘုရားစကားတော်နှင့်အညီ ကျင့်သုံးခြင်းသာတည်း။ ထို့ကြောင့် နံပါတ် (၃) စည်းကမ်းကို သတ်မှတ်ရပါသည်။ ထိုစည်းကမ်းကို မလိုက်နာနိုင်သူကို ဤကျောင်းတိုက်၌ မနေထိုက်သူအဖြစ် သတ်မှတ်ထားသည်။",
            conclusion: "ဤသည်မှာ မဟာဝိဟာရ၏ သံဃာလက်ခံပုံ ဖြစ်၏။"
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="accepting-rules-container">
            <div className="content-wrapper">
                <div className="rules-content">
                    <h1 className="main-title fade-in">{content[language].title}</h1>

                    <section className="novice-section slide-in-left">
                        <h2>{content[language].noviceTitle}</h2>
                        <p>{content[language].noviceContent}</p>
                    </section>

                    <section className="monk-section slide-in-right">
                        <h2>{content[language].monkTitle}</h2>
                        <p className="rules-intro">{content[language].monkRules}</p>
                        <ul className="rules-list">
                            {content[language].rules.map((rule, index) => (
                                <li key={index} className="fade-in-up" style={{animationDelay: `${index * 0.2}s`}}>
                                    {rule}
                                </li>
                            ))}
                        </ul>
                    </section>

                    <section className="explanations fade-in">
                        <div className="explanation-card">
                            <p dangerouslySetInnerHTML={{ __html: content[language].explanation1 }}></p>
                        </div>
                        <div className="explanation-card">
                            <p dangerouslySetInnerHTML={{ __html: content[language].explanation2 }}></p>
                        </div>
                        <div className="explanation-card">
                            <p dangerouslySetInnerHTML={{ __html: content[language].explanation3 }}></p>
                        </div>
                    </section>

                    <p className="conclusion slide-in-bottom">{content[language].conclusion}</p>
                </div>
            </div>
        </div>
    );
};

export default AcceptingRules;